import React, {useState} from 'react'
import {
    Calendar,
    Tag,
    FileText,
    Bookmark,
    Share2,
    TrendingUp,
    AlertCircle,
    Clock,
    Link,
    X,
  } from "lucide-react"
import Loading from '../utils/Loading';
  

const SummaryArea = ({selectedCompany, width='100%', resized=false, summary, recentEvent, onClose, showSummaryAreaSmall}) => {
    const [showShareTooltip, setShowShareTooltip] = useState(false);
    const [showCloseTooltip, setShowCloseTooltip] = useState(false);
    
    const toDate = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    };

    const toJapaneseDate = (timestamp) => {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    };

    const shareToX = () => {
        let text;
        if (summary?.key_points && summary.key_points.length > 0) {
            const strKeyPoints = summary.key_points.map((point => `✅ ${point}`)).join('\n');
            text = encodeURIComponent(strKeyPoints);
        } else {
            text = encodeURIComponent(selectedCompany.title);
        }
        
        const url = encodeURIComponent(selectedCompany.url);

        const xIntentUrl = `https://x.com/intent/tweet?text=${text}&url=${url}`;
        window.open(xIntentUrl, '_blank', 'noopener,noreferrer');
    };
    
    return (
        <div
            className={`${!resized && "w-2/5"} md:p-4 overflow-auto bg-[#f5f5f5] md:bg-gray-50 md:block ${showSummaryAreaSmall ? 'absolute z-[2000]' : ''} overflow-y-auto scrollbar-hide`}
            style={{
                width: showSummaryAreaSmall
                  ? 'calc(100% - 10px)' // スマホ表示時に全幅にする
                  : !resized
                    ? ''
                    : typeof width === 'string' && width.includes('%')
                      ? `calc(${width} - 20px)`
                      : `${width}px`,
                height: showSummaryAreaSmall
                    ? 'calc(100vh - 40px)' // スマホ表示時に全高にする?
                    : '100%', 
                display: showSummaryAreaSmall || window.innerWidth > 767 ? 'block' : 'none'
              }}
        >
            <div className="flex flex-col h-full scrollbar-hide">
                <div className="overflow-y-auto flex-1 min-h-0 scrollbar-hide" style={{ maxHeight: '100%' }}>
                    <div className="space-y-4">
                        {/* 企業情報カード */}
                        <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm">
                            <div className="flex justify-between items-start mb-3">
                            <div>
                                <h3 className="text-xl font-bold text-gray-800">{selectedCompany.company_name}</h3>
                                <div className="flex items-center text-sm text-gray-500 mt-1">
                                <Tag className="h-4 w-4 mr-1" />
                                <span>{selectedCompany.sec_code}</span>
                                <span className="mx-2">|</span>
                                <span>{selectedCompany.industry_name}</span>
                                </div>
                            </div>
                            <div className="flex space-x-2">
                                {/* <button className="p-1.5 rounded-full hover:bg-gray-100">
                                <Bookmark className="h-4 w-4 text-gray-500" />
                                </button> */}
                                <button
                                    className="relative p-1.5 rounded-full hover:bg-gray-100"
                                    onClick={shareToX}
                                    onMouseEnter={() => setShowShareTooltip(true)}
                                    onMouseLeave={() => setShowShareTooltip(false)}
                                    aria-label="Xでシェア"
                                    >
                                    <Share2 className="h-4 w-4 text-gray-500" />

                                    {showShareTooltip && (
                                        <div className="absolute top-7 left-1/2 transform -translate-x-1/2 w-[100px] bg-gray-600 text-white text-xs py-1 px-2 rounded">
                                        Xで共有
                                        </div>
                                    )}
                                </button>
                                <button className="p-1.5 rounded-full hover:bg-gray-100 relative" 
                                    onClick={onClose}
                                    onMouseEnter={() => setShowCloseTooltip(true)}
                                    onMouseLeave={() => setShowCloseTooltip(false)}
                                    aria-label="閉じる">
                                    <X className="h-4 w-4 text-gray-500" />
                                    {showCloseTooltip && (
                                        <div className="absolute top-7 right transform -translate-x-1/2 w-[100px] bg-gray-600 text-white text-xs py-1 px-2 rounded">
                                        閉じる
                                        </div>
                                    )}
                                </button>
                            </div>
                            </div>

                            <div className="flex items-center text-sm text-gray-500 mb-4">
                                <Calendar className="h-4 w-4 mr-1.5" />
                                <span>{toDate(selectedCompany.date)}</span>
                            </div>

                            <div className="mb-4 pb-4 border-b border-gray-100">
                                <div className="flex items-center mb-2">
                                    <FileText className="h-4 w-4 mr-2 text-blue-600" />
                                    <h4 className="font-medium text-gray-700">タイトル</h4>
                                </div>
                                <div className="text-gray-800 pl-6 flex items-center gap-2">
                                    <div>{selectedCompany.title}</div>
                                    <div><a href={`${selectedCompany.url}`} target='_blank'><Link className="h-4 w-4 mr-2 hover:text-gray-600" /></a></div>
                                </div>
                            </div>

                            <div>
                                <div className="flex items-center mb-2">
                                    <TrendingUp className="h-4 w-4 mr-2 text-emerald-600" />
                                    <h4 className="font-medium text-gray-700">要約</h4>
                                </div>
                                <div className="bg-gray-50 p-4 rounded-lg border border-gray-100">
                                    {summary ? 
                                        <p className="text-gray-700 leading-relaxed">{summary.summary}</p>
                                    :
                                        <div className='flex justify-center items-center h-[30px]'><Loading /></div>
                                    }
                                    
                                </div>
                            </div>
                        </div>

                        {/* 重要ポイント */}
                        <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm">
                            <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                            <AlertCircle className="h-4 w-4 mr-2 text-amber-500" />
                            重要ポイント
                            </h4>
                            <ul className="space-y-2 pl-6 text-gray-700">
                                {summary ? summary.key_points?.map((point, index) => (
                                        <li key={index} className="flex items-start">
                                            <span className="mr-2 text-green-600">✅</span>
                                            <span>{point}</span>
                                        </li>
                                    ))
                                    :
                                    <div className='flex justify-center items-center h-[30px]'><Loading /></div>
                                }
                            </ul>

                        </div>

                        {/* 最近の動向 */}
                        <div className="bg-white p-5 rounded-xl border border-gray-200 shadow-sm">
                            <h4 className="font-semibold text-gray-800 mb-3 flex items-center">
                            <Clock className="h-4 w-4 mr-2 text-blue-500" />
                            最近の動向
                            </h4>
                            <ul className="list-disc space-y-2 pl-6 text-gray-700">
                                {recentEvent && recentEvent.slice(0, 5).map((event, index) => (
                                    <li key={index} className="list-item">
                                        <div>
                                            <p className="text-sm py-2">{event.title}</p>
                                            <p className="text-xs">{toJapaneseDate(event.date)}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SummaryArea